var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tdesk-no-search-results-placeholder"},[_c('i',{class:("fas " + _vm.icon)}),_vm._v(" "),_c('h3',{staticStyle:{"text-align":"center"}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }